import { Fragment } from 'react';
import { Text } from '@react-pdf/renderer';
import { styles } from './styles';

const ReportHeader = () => {
  return (
    <Fragment>
      <Text style={styles.headerIWG} fixed>
        ~ Powered By DOCloud ~
      </Text>
    </Fragment>
  );
};

export default ReportHeader;
